import { Moment } from 'moment';

const fromMoment = (momentObj: Moment): Date => momentObj.toDate();

export default fromMoment;
